import Container = Phaser.GameObjects.Container;
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import SoundUtils from "@/utils/sound-utils";
import SpriteUtils from "@/utils/sprite-utils";


// TODO MAKE THIS ROUND BUTTON
export class BattleGiveUpButton extends Container {

    private onPressCallback!: () => unknown;

    constructor(scene: Scene, canvas: HTMLCanvasElement, onPressCallback: () => unknown, clickSound: Phaser.Sound.BaseSound | undefined) {
        super(scene);

        this.scene = scene;
        this.onPressCallback = onPressCallback;

        let giveUpButton = SpriteUtils.addImage(this.scene, 30, 30, Keys.ATLAS_UI, Keys.UI_ART_GIVE_UP_BUTTON);

        giveUpButton.setInteractive().on('pointerup', () => {
            SoundUtils.play(clickSound);
            if (this.onPressCallback != null) { this.onPressCallback(); }
        })

        this.add(giveUpButton);
    }
}
